export default __webpack_public_path__ + "6765311d5a9b5f90798aae35b55545c6.png";